import { useEffect } from 'react';
import { Button, Result, Spin } from 'antd';
import { Link, isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { NotFoundPage } from './NotFoundPage.js';

const chunkErrorPatterns = [
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
  'error loading dynamically imported module'
];

function errorMessage(error: unknown) {
  if (error instanceof Error) return error.message;
  return typeof error === 'string' ? error : '';
}

export function RouteErrorPage() {
  const error = useRouteError();
  const message = errorMessage(error);
  const chunkLoadFailed = !isRouteErrorResponse(error) && chunkErrorPatterns.some((pattern) => message.includes(pattern));

  useEffect(() => {
    if (!chunkLoadFailed) return;
    const retryKey = `after-sales-erp-chunk-reload:${message}`;
    if (sessionStorage.getItem(retryKey)) return;
    sessionStorage.setItem(retryKey, '1');
    window.location.reload();
  }, [chunkLoadFailed, message]);

  if (chunkLoadFailed && !sessionStorage.getItem(`after-sales-erp-chunk-reload:${message}`))
    return <div className="route-loading"><Spin size="large" tip="正在加载最新版本" /></div>;
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  const forbidden = isRouteErrorResponse(error) && error.status === 403;
  return <Result status={forbidden ? '403' : '500'} title={forbidden ? '无权访问' : '页面加载失败'}
    subTitle={forbidden ? '当前账号没有访问该页面的权限。' : chunkLoadFailed ? '新版页面资源未能加载，请刷新重试。' : '页面发生异常，请刷新重试；若问题持续，请联系管理员。'}
    extra={<><Button type="primary" onClick={() => window.location.reload()}>刷新重试</Button><Link to="/"><Button>返回工作台</Button></Link></>} />;
}
